<template>
   <b-modal
    ref="modal"
    title="Gửi lại email hoá đơn"
    @ok="handleSubmit"
    ok-title="Gửi email"
    ok-variant="info"
    cancel-title="Đóng"
    :ok-disabled="isSubmitting"
    no-close-on-backdrop
    size="md"
    > <template v-if="invoice"
      > <b-form-group
        label="Email người nhận *"
        label-class="font-weight-bold"
        :invalid-feedback="emailError"
        :state="emailState"
        description="Có thể nhập email khác với email gốc trên hoá đơn."
        > <b-form-input
          v-model="form.email"
          size="sm"
          type="email"
          placeholder="Nhập email..."
          :state="emailState"
          @input="$v.form.email.$touch()"
        ></b-form-input
        > </b-form-group
      >
      <div class="bg-light p-3 rounded">
         <small class="text-muted">Email gốc trên hoá đơn:</small>
        <div>{{ invoice.buyerEmail || 'Không có' }}</div>

      </div>
       </template
    > <loading-overlay
      :active="isSubmitting"
      :is-full-page="false"
      > <template #default
        >
        <div class="text-center">
           <b-spinner
            variant="info"
            small
          ></b-spinner
          > <span class="ml-2 text-muted">Đang gửi...</span>
        </div>
         </template
      > </loading-overlay
    > </b-modal
  >
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, email } from 'vuelidate/lib/validators'
  import LoadingOverlay from '@/view/components/common/LoadingOverlay.vue'
  import { EINVOICE_RESEND_EMAIL } from '@/core/services/store/modules/einvoice/einvoice.module'
  import { getToastInstance } from '@/utils/toastHelper'

  const { makeToastSuccess, makeToastFailure } = getToastInstance()

  export default {
    name: 'EInvoiceResendEmailModal',
    components: { LoadingOverlay },
    mixins: [validationMixin],
    props: {
      invoice: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        isSubmitting: false,
        form: {
          email: '',
        },
      }
    },
    validations: {
      form: {
        email: { required, email },
      },
    },
    computed: {
      emailState() {
        const { $dirty, $error } = this.$v.form.email
        return $dirty ? !$error : null
      },
      emailError() {
        if (!this.$v.form.email.required) return 'Vui lòng nhập email'
        if (!this.$v.form.email.email) return 'Email không hợp lệ'
        return ''
      },
    },
    methods: {
      show() {
        this.form.email = this.invoice?.buyerEmail || ''
        this.$v.$reset()
        this.$refs.modal.show()
      },
      hide() {
        this.$refs.modal.hide()
      },
      async handleSubmit(bvModalEvt) {
        bvModalEvt.preventDefault()
        this.$v.form.$touch()
        if (this.$v.form.$invalid) return

        this.isSubmitting = true
        try {
          await this.$store.dispatch(EINVOICE_RESEND_EMAIL, {
            salesInvoiceId: this.invoice.salesInvoiceId,
            saleType: this.invoice.saleType,
            email: this.form.email,
          })
          makeToastSuccess('Đã gửi lại email thành công')
          this.$emit('sent')
          this.hide()
        } catch (err) {
          const msg = err?.message || 'Gửi email thất bại'
          makeToastFailure(msg)
        } finally {
          this.isSubmitting = false
        }
      },
    },
  }
</script>

